import restApiConnection from '@/services/api/providers/Connection'
import RestApiBase from '@/services/models/RestApiBase'
import OperationOfficeType from '@/types/operationOffice'
import UserSession from '@/services/models/UserSession'
import { AxiosResponse } from 'axios'
import { CacheAxiosResponse } from 'axios-cache-interceptor'
import { CACHE_TTL_DEFAULT } from '@/config'

export default class SelfOffice extends RestApiBase {
  public static async get(): Promise<AxiosResponse<OperationOfficeType[]>> {
    return this.sync('GetOperationOffices', this.getOwn)
  }

  public static getOwn = async (): Promise<
    CacheAxiosResponse<OperationOfficeType[]> | undefined
  > => {
    const config = {
      cache: {
        ttl: CACHE_TTL_DEFAULT,
      },
      params: {
        user_session_id: UserSession.getStoredUserId(),
      },
    }

    return await restApiConnection
      .get('/operation_offices', config)
      .catch(async (error) => {
        console.error('API Call Failed on OperationOffice. Error:', error)
        throw error
      })
  }
}
